import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

import LoginPage from "@/views/app/v2/LoginPage.vue";
import UnidadesPage from "@/views/app/v2/UnidadesPage.vue";
import ConsultaAvancadaPage from "@/views/app/v2/ConsultaAvancadaPage.vue";
import UnidadePage from "@/views/app/v2/Unidades/UnidadePage.vue";
import SiloPage from "@/views/app/v2/Unidades/Unidade/SiloPage.vue";
import UsuarioPage from "@/views/app/v2/UsuarioPage.vue";
import RelatorioEstacao from "@/views/app/v2/Relatorios/RelatorioEstacao.vue";
import AeracaoPage from "@/views/app/v2/Unidades/Unidade/AeracaoPage.vue";
import RelatorioAeracao from "@/views/app/v2/Relatorios/RelatorioAeracao.vue";
import RelatorioTermometria from "@/views/app/v2/Relatorios/RelatorioTermometria.vue";
import RelatorioLogs from "@/views/app/v2/Relatorios/RelatorioLogs.vue";
import AddLeiturasPage from "@/views/app/v2/Leituras/AddLeiturasPage.vue";
import LeiturasAutomaticasPage from "@/views/app/v2/Leituras/LeiturasAutomaticasPage.vue";
import WinckieelIntelligence from "@/views/app/WinckieelIntelligence.vue";
import ParametrosCheckoutPage from "@/views/app/v2/ParametrosCheckoutPage.vue";
const routes = [
	{
		path: "/v2/login",
		name: "LoginPage",
		component: LoginPage,
        meta: { isAuthenticated: true, title: 'Login - Winckieel Cloud' }
	},
	{
		path: "/minha-conta",
		name: "UsuarioPage",
		component: UsuarioPage,
        meta: { requiresAuth: true, title: 'Conta - Winckieel Cloud' }
	},
	{
		path: "/v2/unidades",
		name: "UnidadesPage",
		component: UnidadesPage,
		meta: { requiresAuth: true, title: 'Unidades - Winckieel Cloud'},
	},
	{
		path: "/v2/consulta-avancada",
		name: "ConsultaAvancadaPage",
		component: ConsultaAvancadaPage,
		meta: { requiresAuth: true, title: 'Consulta Avançada - Winckieel Cloud'},
	},
	{
		path: "/v2/unidades/:unidade",
		name: "UnidadeDetailsPage",
		component: UnidadePage,
		meta: { requiresAuth: true, title: 'Winckieel Cloud' },
	},
	{
		path: "/v2/unidades/:unidade/silos/:silo",
		name: "SiloDetailsPage",
		component: SiloPage,
		meta: { requiresAuth: true, title: 'Silo - Winckieel Cloud' },
	},
	{
		path: "/v2/parametros-checkout/:unidade",
		name: "ParametrosCheckoutPage",
		component: ParametrosCheckoutPage,
		meta: { requiresAuth: true, title: 'Replicar Parâmetros - Winckieel Cloud' },
	},
	{
		path: "/v2/unidades/:unidade/relatorios/estacao",
		name: "RelatorioEstacaoPage",
		component: RelatorioEstacao,
		meta: { requiresAuth: true, title: 'Relatório Estação - Winckieel Cloud' },
	},
    {
        path: "/v2/unidades/:unidade/relatorios/silos/termometria",
		name: "RelatorioTermometriaPage",
		component: RelatorioTermometria,
		meta: { requiresAuth: true, title: 'Relatório Termometria - Winckieel Cloud' },
    },
    {
        path: "/v2/unidades/:unidade/relatorios/silos/aeracao",
		name: "RelatorioAeracaoPage",
		component: RelatorioAeracao,
		meta: { requiresAuth: true, title: 'Relatório Aeração - Winckieel Cloud' },
    },
	{
		path: "/v2/unidades/:unidade/relatorios/logs",
		name: "RelatorioLogsPage",
		component: RelatorioLogs,
		meta: { requiresAuth: true, requiresAdmin: true, title: 'Relatório Logs - Winckieel Cloud' },
	},
    {
        path: "/v2/unidades/:unidade/configuracoes/aeracao",
		name: "AeracaoPage",
		component: AeracaoPage,
		meta: { requiresAuth: true, title: 'Aeração - Winckieel Cloud' },
    },
    {
        path: "/v2/unidades/:unidade/leituras/adicionar",
		name: "AddLeiturasPage",
		component: AddLeiturasPage,
		meta: { requiresAuth: true, title: 'Adicionar Leitura - Winckieel Cloud' },
    },
    {
        path: "/v2/unidades/:unidade/leituras/leituras-automaticas",
		name: "LeiturasAutomaticasPage",
		component: LeiturasAutomaticasPage,
		meta: { requiresAuth: true, title: 'Leituras Automáticas - Winckieel Cloud' },
    },
	{
		path: "/v2/unidades/:unidade/winckieel-intelligence",
		name: "WinckieelIntelligencePage",
		component: WinckieelIntelligence,
		meta: { requiresAuth: true, title: 'WINCK IA - Winckieel Cloud' },
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		redirect: "/v2/unidades"
		
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title;
    const isAuthenticated = store.getters["auth/isAuthenticated"];

    if (to.name === "LoginPage" && isAuthenticated) {
        next({ name: "UnidadesPage" });
        return;
    }

	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (!isAuthenticated) {
			next({ name: "LoginPage" });
		} else {
			if (to.matched.some((record) => record.meta.requiresAdmin)) {
				const user = store.getters["auth/getUser"];
				if (!user || user.tipo_usuario !== 'administrador') {
					next({ name: 'UnidadesPage' });
					return;
				}
			}
			next();
		}
	} else {
		next();
	}
});

export default router;
